import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '../core/config';
import { Socket } from 'ngx-socket-io';

@Injectable({ providedIn: 'root' })
export class UnifiedaiService {
  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private socket: Socket
  ) {  }

  // Always use only Compare API
  getSalespersonCompare(params: any): Observable<any> {
    return this.http.post(
      `${this.configService.apiUrl}/salesperson/getLastMonthwithCompareData`,
      params
    );
  }

    // Manufacturer Compare API
  getManufacturerCompare(params: any): Observable<any> {
    return this.http.post(
      `${this.configService.apiUrl}/manufacturers/getLastMonthwithCompareData`,
      params
    );
  }

    // Surgeon Compare API
  getSurgeonCompare(params: any): Observable<any> {
    return this.http.post(
      `${this.configService.apiUrl}/surgeons/getLastMonthwithCompareData`,
      params
    );
  }

    // Territory Compare API
  getTerritoryCompare(params: any): Observable<any> {
    return this.http.post(
      `${this.configService.apiUrl}/territories/getLastMonthwithCompareData`,
      params
    );
  }

    // Hospital Compare API
  getHospitalCompare(params: any): Observable<any> {
    console.log('Hospital Compare Params:', params);
    return this.http.post(
      `${this.configService.apiUrl}/hospitals/getLastMonthwithCompareData`,
      params
    );
  }
  
    // Procedure Compare API
  getProcedureCompare(params: any): Observable<any> {
    return this.http.post(
      `${this.configService.apiUrl}/procedures/getLastMonthwithCompareData`,
      params
    );
  }
  
  // Last finalized month API (for default filter)
  getLastFinalizedMonth(): Observable<any> {
    return this.http.get(`${this.configService.apiUrl}/commission/getLastFinalizedMonthAI`);
  }
}
